import styled from 'styled-components';
import BiddingField from './BiddingField';
import { colorSchema } from 'utils/style';

export default styled(BiddingField)`
  .bidding-field {
    display: flex;
    position: relative;
    flex-direction: column;
    margin: 1.6rem;

    &__form-label {
      width: 100%;
      margin-bottom: 0.8rem;
      font-family: Roboto;
      font-size: 1.4rem;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: normal;
      color: ${colorSchema('primary700')};
    }

    &__form-input {
      display: flex;
      justify-content: center;
      width: 100%;
      border: solid 1px ${colorSchema('grey500')};
      background-color: ${colorSchema('white')};
      margin-bottom: 8px;

      input {
        font-size: 1.6rem;
        height: 4.8rem;
        width: 100%;
        padding: 1.6rem;
        font-family: Roboto;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.31;
        letter-spacing: normal;
      }

      span {
        font-size: 1.6rem;
        height: 4.8rem;
        padding: 1.6rem;
      }
    }

    &__actions-primary {
      width: 100%;

      .button-loading {
        margin-top: 0.8rem;
        &__button {
          width: 100%;
        }
      }
    }
  }
`;
